"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorType = exports.SensorStatus = void 0;
var SensorStatus;
(function (SensorStatus) {
    SensorStatus["Active"] = "ACTIVE";
    SensorStatus["Inactive"] = "INACTIVE";
    SensorStatus["Maintenance"] = "MAINTENANCE";
    SensorStatus["Pending"] = "PENDING";
})(SensorStatus = exports.SensorStatus || (exports.SensorStatus = {}));
var SensorType;
(function (SensorType) {
    SensorType["AIR_QUALITY"] = "AIR_QUALITY";
    SensorType["CO2"] = "CO2";
    SensorType["ELECTRICAL"] = "ELECTRICAL";
    SensorType["HUMIDITY"] = "HUMIDITY";
    SensorType["HVAC_CONDENSER_MONITOR"] = "HVAC_CONDENSER_MONITOR";
    SensorType["HVAC_AIRHANDLER_MONITOR"] = "HVAC_AIRHANDLER_MONITOR";
    SensorType["LEAK_DETECTOR"] = "LEAK_DETECTOR";
    SensorType["LIGHT"] = "LIGHT";
    SensorType["PM10"] = "PM10";
    SensorType["PM25"] = "PM25";
    SensorType["POWER"] = "POWER_MONITOR";
    SensorType["POWER_ALT"] = "POWER";
    SensorType["PRESSURE"] = "PRESSURE";
    SensorType["TEMPERATURE"] = "TEMPERATURE";
    SensorType["VOC"] = "VOC";
    SensorType["WATER_QUALITY"] = "WATER_QUALITY";
    SensorType["MOTION"] = "MOTION";
    SensorType["OTHER"] = "OTHER";
    // CT sensors are used to measure current transformer values
    SensorType["HVAC_CONDENSER_MONITOR_CT"] = "HVAC_CONDENSER_MONITOR_CT";
    SensorType["HVAC_AIRHANDLER_MONITOR_CT"] = "HVAC_AIRHANDLER_MONITOR_CT";
    // legacy alias for HVAC_AIRHANDLER_MONITOR
    SensorType["HVAC"] = "HVAC_AIRHANDLER_MONITOR";
})(SensorType = exports.SensorType || (exports.SensorType = {}));
